import { PropsWithChildren } from "react";
import "../../index.scss";
import { AlertBar } from "../AlertBar";

export const Main = ({ children }: PropsWithChildren<unknown>) => (
	<div className="flex flex-col grow py-3 px-4 h-full w-full">
		<AlertBar />
		{children}
	</div>
);
